import Vue from 'vue';
import App from './App';
import router from './router';
import Antd from 'ant-design-vue';
import store from './store';
import request from 'utils/request';
import db from 'utils/localstorage';
import 'utils/install';
import 'ant-design-vue/dist/antd.css';

Vue.config.productionTip = false;
Vue.use(Antd);
Vue.use({
  install(Vue) {
    Vue.prototype.$db = db;
  },
});

Vue.prototype.$post = request.post;
Vue.prototype.$post2 = request.post2;
Vue.prototype.$get = request.get;
Vue.prototype.$put = request.put;
Vue.prototype.$put2 = request.put2;
Vue.prototype.$delete = request.delete;
Vue.prototype.$cmsDelete = request.delete2;
Vue.prototype.$export = request.export;
Vue.prototype.$exportQuery = request.exportQuery;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
